import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import "./TeacherDataReport.scss";
import Layout from "../../Layout/Layout";
import TeacherReportCard from "./TeacherReportCard/TeacherReportCard";
import { useChartContext } from "../../../../context/ChartContext";

const TeacherReport = ({ t, user }) => {
  const { selectedTeacher } = useChartContext();

  const [isTabletOrMobileView, setIsTabletOrMobileView] = useState(
    window.innerWidth <= 991
  );
  const [isTabletView, setIsTabletView] = useState(
    window.innerWidth > 767 && window.innerWidth <= 991
  );
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => {
      setIsTabletOrMobileView(window.innerWidth <= 991);
      setIsTabletView(window.innerWidth > 767 && window.innerWidth <= 991);
      setIsMobileView(window.innerWidth <= 767);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="teacher-report-page">
      <Layout isReportAvailable={true} isMobileView={isMobileView}>
        <TeacherReportCard
          user={user}
          isTabletOrMobileView={isTabletOrMobileView}
          isMobileView={isMobileView}
          isTabletView={isTabletView}
          selectedTeacher={selectedTeacher}
        />
      </Layout>
    </div>
  );
};

export default withTranslation()(TeacherReport);
